import {
  FETCH_AGENCIES,
  CREATE_AGENCY,
  UPDATE_AGENCY,
  CLEAR_AGENCIES_STATE
} from './mutations-types'
export default {
  [FETCH_AGENCIES] (state, payload) {
    state.agencies = payload
  },
  [CREATE_AGENCY] (state, payload) {
    state.agencies.push(payload)
  },
  [CLEAR_AGENCIES_STATE] (state) {
    state.agencies = []
    state.selectedAgency = null
  },
  [UPDATE_AGENCY] (state, payload) {
    const index = state.agencies.findIndex(a => a.id === payload.id)
    if (index !== -1) {
      state.agencies.splice(index, 1, payload)
    }
  }
}
